import React from 'react';

interface WarningProps {
    color: string
}

const Warning = ({color = 'white'}: WarningProps) => {
    return (
        <svg width="39px" height="34px" viewBox="0 0 39 34">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="baseline-warning-24px" transform="translate(-2.000000, -4.000000)">
                    <polygon id="Path" points="0 0 43 0 43 43 0 43" />
                    <path d="M2,38 L41,38 L21.5,4 L2,38 Z M23.2727273,32.6315789 L19.7272727,32.6315789 L19.7272727,29.0526316 L23.2727273,29.0526316 L23.2727273,32.6315789 Z M23.2727273,25.4736842 L19.7272727,25.4736842 L19.7272727,18.3157895 L23.2727273,18.3157895 L23.2727273,25.4736842 Z" id="Shape" fill={color} fillRule="nonzero" />
                </g>
            </g>
        </svg>
    )
};

export default Warning;